module.exports = __webpack_public_path__ + "assets/img/05.admin-server-2.18839ed3.png";